<div id='wrapper' [ngClass]="{'thank-you' : !formService.formActive, 'loading' : formService.formLoading}" cdkTrapFocus>
	<div id='top-parts'>
		<app-header></app-header>
	</div>
	<form id='middle-parts' class='form-body steps-amount-{{formService.totalStepsAmount}}' [formGroup]='formService.mainForm' *ngIf='formService.formActive'>
		<div id='form-steps'
		     [@slide]="formService.currentStep">

			<!-- MovingFrom -->
			<app-moving-from [style.display]='formService.shouldShow( "movingFrom" ) ? "flex" : "none"' ></app-moving-from>

			<!-- PropertyTypeFrom | optional -->
			<app-property-type-from *ngIf='shouldShowPropertyType( "from" )' [style.display]='formService.shouldShow( "propertyTypeFrom" ) ? "flex" : "none"'></app-property-type-from>

			<!-- PropertyTypeDetailsFrom | optional | based on property-type-from -->
			<app-property-type-details-from *ngIf='shouldShowPropertyTypeDetails( "from" )' [style.display]='formService.shouldShow( "propertyTypeDetailsFrom" ) ? "flex" : "none"'></app-property-type-details-from>

			<!-- MovingTo -->
			<app-moving-to [style.display]='formService.shouldShow( "movingTo" ) ? "flex" : "none"'></app-moving-to>

			<!-- PropertyTypeTo | optional -->
			<app-property-type-to *ngIf='shouldShowPropertyType( "to" )' [style.display]='formService.shouldShow( "propertyTypeTo" ) ? "flex" : "none"'></app-property-type-to>

			<!-- PropertyTypeDetailsTo | optional | based on property-type-to -->
			<app-property-type-details-to *ngIf='shouldShowPropertyTypeDetails( "to" )' [style.display]='formService.shouldShow( "propertyTypeDetailsTo" ) ? "flex" : "none"'></app-property-type-details-to>

			<app-moving-size [style.display]='formService.shouldShow( "movingSize" ) ? "flex" : "none"'></app-moving-size>

			<!-- MovingContent -->
			<app-moving-content *ngIf='shouldShowMovingContent()' [style.display]='formService.shouldShow( "movingContent" ) ? "flex" : "none"'></app-moving-content>

			<!-- MovingBoxes -->
			<app-moving-boxes *ngIf='shouldShowMovingBoxes()' [style.display]='formService.shouldShow( "movingBoxes" ) ? "flex" : "none"'></app-moving-boxes>

			<!-- UploadPictures | optional | only when movingBoxes path -->
			<app-upload-pictures *ngIf='shouldShowUploadPictures()' [style.display]='formService.shouldShow( "uploadPictures" ) ? "flex" : "none"'></app-upload-pictures>

			<!-- MovingDate -->
			<app-moving-date [style.display]='formService.shouldShow( "movingDate" ) ? "flex" : "none"'></app-moving-date>

			<!-- ConsentMovers -->
			<app-consent-movers *ngIf='shouldShowConsentMovers()' [style.display]='formService.shouldShow( "consentMovers" ) ? "flex" : "none"'></app-consent-movers>

			<!-- NamEmailPhone -->
			<app-name-email-phone [style.display]='formService.shouldShow( "nameEmailPhone" ) ? "flex" : "none"'></app-name-email-phone>
		</div>
	</form>
	<app-post-submit *ngIf='!formService.formActive'></app-post-submit>
	<app-background></app-background>
	<app-footer></app-footer>
</div>
